import { Matrix } from "./Matrix";

export class GroundStation {
    readonly latitude: number;
    readonly longitude: number;
    readonly altitude: number;
    private _geoToTopoMat: Matrix;

    constructor(latitude: number, longitude: number, altitude: number) {
        this.latitude = latitude;
        this.longitude = longitude;
        this.altitude = altitude;
    }

    /** Get the rotation matrix for transforming to topocentric coordinates */
    geographicToTopocentricMatrix(): Matrix {
        if (!this._geoToTopoMat) {
            let sLat = Math.sin(this.latitude);
            let cLat = Math.cos(this.latitude);
            let sLong = Math.sin(this.longitude);
            let cLong = Math.cos(this.longitude);
            this._geoToTopoMat = new Matrix([-sLong, cLong, 0.0, -sLat * cLong, -sLat * sLong, cLat, cLat * cLong, cLat * sLong, sLat]);
        }
        return this._geoToTopoMat;
    }
}



// WEBPACK FOOTER //
// ./src/GroundStation.ts